import { formatArea, formatLengthKm } from '../../utils/formatters';

interface StatsCardsProps {
  areaM2: number;
  shapeLengthKm: number;
}

export function StatsCards({ areaM2, shapeLengthKm }: StatsCardsProps) {
  return (
    <section className="stats-group left-stats">
      <div className="stat-card matte-frame">
        <span className="stat-label">当前道路绿化面积</span>
        <span className="stat-main">
          <span className="stat-value">{formatArea(areaM2)}</span>
          <span className="stat-unit">㎡</span>
        </span>
      </div>

      <div className="stat-card matte-frame">
        <span className="stat-label">当前道路绿化长度</span>
        <span className="stat-main">
          <span className="stat-value">{formatLengthKm(shapeLengthKm)}</span>
          <span className="stat-unit">km</span>
        </span>
      </div>
    </section>
  );
}
